import { RegionShared } from "@1games-ru/region-shared";
import {
  BankGetTransactionsRequest,
  BankGetTransactionsResponse,
} from "@1games-ru/region-shared/dist/backend/requests/bank";
import { BankTariffDto } from "@1games-ru/region-shared/dist/types/bank/bank";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default class BankMpProvider {
  public static async getBankCharacter(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankGetCharacterResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      unknown,
      typeof RegionShared.Backend.Responses.BankGetCharacterResponse
    >(RegionShared.Backend.Events.Bank.BankGetCharacter, {});
  }

  public static createBankAccount(
    tariffId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankCreateAccountResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.BankCreateAccountRequest,
      typeof RegionShared.Backend.Responses.BankCreateAccountResponse
    >(RegionShared.Backend.Events.Bank.CreateBankAccount, { tariffId });
  }

  public static async getBankTariffs(): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<BankGetTariffsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<unknown, BankGetTariffsResponse>(
      RegionShared.Backend.Events.Bank.BankGetTariffs,
      {},
    );
  }

  public static async deposit({
    depositAmount,
    atmId,
    filialId,
  }: {
    depositAmount: number;
    atmId: number | null;
    filialId: number | null;
  }): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankDepositResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.BankDepositRequest,
      typeof RegionShared.Backend.Responses.BankDepositResponse
    >(RegionShared.Backend.Events.Bank.BankDeposit, {
      depositAmount,
      atmId,
      filialId,
    });
  }

  public static async withdraw({
    withdrawAmount,
    atmId,
    filialId,
  }: {
    withdrawAmount: number;
    atmId: number | null;
    filialId: number | null;
  }): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankWithdrawResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.BankWithdrawRequest,
      typeof RegionShared.Backend.Responses.BankWithdrawResponse
    >(RegionShared.Backend.Events.Bank.BankWithdraw, {
      withdrawAmount,
      atmId,
      filialId,
    });
  }

  public static async getAtmList(
    atmId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankGetAtmResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      unknown,
      typeof RegionShared.Backend.Responses.BankGetAtmResponse
    >(RegionShared.Backend.Events.Bank.BankGetAtm, { atmId });
  }

  public static async transfer({
    transferAmount,
    accountNumber,
    atmId,
    filialId,
  }: {
    transferAmount: number;
    accountNumber: string;
    atmId: number | null;
    filialId: number | null;
  }): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankTransferResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.BankTransferRequest,
      typeof RegionShared.Backend.Responses.BankTransferResponse
    >(RegionShared.Backend.Events.Bank.BankTransfer, {
      transferAmount,
      accountNumber,
      atmId,
      filialId,
    });
  }

  public static async changeTariff({
    tariffId,
  }: {
    tariffId: number;
  }): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BankChangeTariffResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.BankChangeTariffRequest,
      typeof RegionShared.Backend.Responses.BankChangeTariffResponse
    >(RegionShared.Backend.Events.Bank.BankChangeTariff, { tariffId });
  }

  public static async getTransactions(
    request: BankGetTransactionsRequest,
  ): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<BankGetTransactionsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      BankGetTransactionsRequest,
      BankGetTransactionsResponse
    >(RegionShared.Backend.Events.Bank.BankGetTransactions, request);
  }
}

// TODO: ask backend to add these types to region-shared
type BankGetTariffsResponse = BankTariffDto[];
// type BankGetTransactionsResponse = {
//   id: string;
//   characterId: number;
//   operation: "increment" | "decrement";
//   type: "withdraw_cash" | "deposit_cash" | "transfer_account";
//   amount: number;
//   feeAmount: number;
//   reasonId: number | null;
//   reasonType: unknown | null;
//   filialId: number | null;
//   atmId: number | null;
//   relatedTxId: string | null;
// }[];
